import { GetFullUserNameType } from './interfaces';

export const getFullUserName: GetFullUserNameType = ({
  firstName,
  lastName,
}) => {
  if (!firstName && !lastName) return '';

  return `${firstName} ${lastName}`.replace(/\s+/g, ' ').trim();
};

// A key existing isn't enough — the backend can pre-seed a 0 placeholder
// entry per invited event before the user has ever actually entered any of
// them. Only a nonzero value reflects a real recorded entrance.
export const resolveIsFirstTimeUser = (
  lastEntranceTimestamp: { [key: string]: number } | undefined | null,
): boolean =>
  !Object.values(lastEntranceTimestamp ?? {}).some(
    (timestamp) => timestamp !== 0,
  );
